import useOverrideBackgroundColor from "src/hooks/global-background/useOverrideBackgroundColor";
import usePalette from "src/hooks/usePalette";

const PaletteSyncBackgroundColor = () => {
	const { tertiary } = usePalette();
	useOverrideBackgroundColor(tertiary);

	return null;
};
export default PaletteSyncBackgroundColor;
